/* GG — agregar al carrito desde la tarjeta (home y colecciones).
   Por que existe: el <buy-button> del tema dispara "product:added" y el mini-cart
   responde con _openMiniCart() + scrollTo(top), o sea te abre el carrito y te
   manda al principio de la pagina. Aqui hacemos el POST nosotros y NO disparamos
   ese evento. La animacion arranca en el mismo click (0 ms), asi que se siente
   instantaneo aunque el servidor tarde. Sin dependencias. */
(function () {
  'use strict';
  if (window.__ggAddRapido) return;
  window.__ggAddRapido = true;

  var FORMS = '.gg-card__masform, .gg-vc-quickform';
  var BOTONES = '.gg-card__mas, .gg-vc-quick';
  var VUELO_MS = 620;
  var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function iconoCarrito() {
    return document.querySelector('.header__cart-toggle') ||
           document.querySelector('[data-action="toggle-mini-cart"]') ||
           document.querySelector('header a[href*="/cart"]') ||
           document.querySelector('a[href*="/cart"]');
  }
  function badge() { return document.querySelector('.header__cart-count'); }

  function pintarBadge(n) {
    var b = badge();
    if (!b) return;
    b.textContent = n;
    b.classList.remove('gg-badge-pop');
    void b.offsetWidth;
    b.classList.add('gg-badge-pop');
  }
  function badgeActual() {
    var b = badge();
    var n = b ? parseInt((b.textContent || '0').replace(/\D/g, ''), 10) : 0;
    return isNaN(n) ? 0 : n;
  }

  /* la foto del producto: en el home vive en .gg-card, en coleccion en .product-item */
  function fotoDe(form) {
    var caja = form.closest('.gg-card') || form.closest('.product-item') ||
               form.closest('article') || form.parentElement;
    if (!caja) return null;
    var cands = caja.querySelectorAll(
      '.gg-card__shot img, .product-item__primary-image, .product-item__image-wrapper img, .aspect-ratio img, img');
    for (var i = 0; i < cands.length; i++) {
      var r = cands[i].getBoundingClientRect();
      if (r.width > 24 && r.height > 24) return cands[i];   // descarta iconos y pixeles
    }
    return null;
  }

  /* vuelo hacia el carrito. Si no hay foto usable, vuela una pastilla dorada
     desde el propio boton: nunca se queda sin feedback. */
  function volar(form, boton) {
    if (!suave) return;
    var destino = iconoCarrito();
    if (!destino) return;
    var d = destino.getBoundingClientRect();
    if (!d.width) return;

    var img = fotoDe(form);
    var clon, o;

    if (img) {
      o = img.getBoundingClientRect();
      clon = img.cloneNode(true);
      clon.removeAttribute('loading');
      clon.removeAttribute('srcset');
      clon.removeAttribute('sizes');
      clon.removeAttribute('class');
      clon.style.cssText = 'position:fixed;z-index:9999;pointer-events:none;margin:0;padding:0;max-width:none;' +
        'left:' + o.left + 'px;top:' + o.top + 'px;width:' + o.width + 'px;height:' + o.height + 'px;' +
        'object-fit:contain;border-radius:10px;filter:drop-shadow(0 10px 18px rgba(19,39,26,.32));';
    } else {
      o = (boton || form).getBoundingClientRect();
      if (!o.width) return;
      clon = document.createElement('span');
      clon.style.cssText = 'position:fixed;z-index:9999;pointer-events:none;border-radius:50%;' +
        'background:#deaa50;box-shadow:0 6px 16px -4px rgba(19,39,26,.45);' +
        'left:' + o.left + 'px;top:' + o.top + 'px;width:' + o.width + 'px;height:' + o.height + 'px;';
    }
    document.body.appendChild(clon);

    var dx = (d.left + d.width / 2) - (o.left + o.width / 2);
    var dy = (d.top + d.height / 2) - (o.top + o.height / 2);

    var quitar = function () { if (clon.parentNode) clon.remove(); };
    var rebote = function () {
      destino.classList.remove('gg-cart-catch');
      void destino.offsetWidth;
      destino.classList.add('gg-cart-catch');
      setTimeout(function () { destino.classList.remove('gg-cart-catch'); }, 520);
    };

    if (typeof clon.animate === 'function') {
      var anim = clon.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx * 0.45 + 'px,' + (dy * 0.28 - 46) + 'px) scale(.62)', opacity: .96, offset: .5 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12)', opacity: .25 }
      ], { duration: VUELO_MS, easing: 'cubic-bezier(.5,-0.2,.5,1)', fill: 'forwards' });
      anim.onfinish = function () { quitar(); rebote(); };
    } else {
      clon.style.transition = 'transform ' + VUELO_MS + 'ms cubic-bezier(.5,-0.2,.5,1), opacity ' + VUELO_MS + 'ms ease';
      requestAnimationFrame(function () {
        clon.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.12)';
        clon.style.opacity = '.25';
      });
      setTimeout(function () { quitar(); rebote(); }, VUELO_MS);
    }
    setTimeout(quitar, VUELO_MS + 500);
  }

  function confirmar(boton) {
    if (!boton) return;
    var original = boton.innerHTML;
    boton.classList.add('is-ok');
    boton.innerHTML = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" ' +
      'stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M4.5 12.5l5 5 10-11"/></svg>';
    setTimeout(function () {
      boton.innerHTML = original;
      boton.classList.remove('is-ok');
    }, 1100);
  }

  function aviso(texto) {
    var t = document.createElement('div');
    t.className = 'gg-toast';
    t.textContent = texto;
    document.body.appendChild(t);
    setTimeout(function () { t.classList.add('is-in'); }, 10);
    setTimeout(function () {
      t.classList.remove('is-in');
      setTimeout(function () { t.remove(); }, 320);
    }, 2600);
  }

  function agregar(form, boton) {
    if (form.dataset.ggOcupado === '1') return;      // anti doble disparo
    var id = form.querySelector('[name="id"]');
    var cant = form.querySelector('[name="quantity"]');
    if (!id || !id.value) return;
    var q = parseInt(cant && cant.value, 10) || 1;

    form.dataset.ggOcupado = '1';
    setTimeout(function () { form.dataset.ggOcupado = '0'; }, 900);

    /* 1. feedback YA: no esperamos al servidor */
    volar(form, boton);
    confirmar(boton);
    pintarBadge(badgeActual() + q);

    /* 2. el POST va por detras */
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: id.value, quantity: q })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (e) { throw new Error(e && e.description ? e.description : 'No se pudo agregar'); });
      }
      /* 3. el numero real, por si habia otra pestana abierta */
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (c) { return c.json(); })
        .then(function (c) {
          pintarBadge(c.item_count);
          /* OJO: el tema escucha en document.documentElement (<html>). Disparar
             en document NO llega (los eventos suben, no bajan): hay que emitirlo
             desde un nodo de dentro para que burbujee hasta <html>. */
          (iconoCarrito() || document.body).dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true, detail: { scrollToTop: false }   // sin detail el tema scrollea al tope
          }));
        });
    }).catch(function (err) {
      pintarBadge(Math.max(0, badgeActual() - q));
      aviso(err && err.message ? err.message : 'No se pudo agregar al carrito');
    });
  }

  /* Se engancha en CLICK (capture) para ser lo primero que corre: asi ningun
     script del tema puede quedarse el evento antes. El submit queda de respaldo
     para el teclado. */
  document.addEventListener('click', function (e) {
    var boton = e.target.closest && e.target.closest(BOTONES);
    if (!boton) return;
    var form = boton.closest(FORMS) || boton.closest('form');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    agregar(form, boton);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest(FORMS);
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    agregar(form, form.querySelector('button[type="submit"]'));
  }, true);
})();
